import { EntityView } from '@/common/entityFramework/entityView/EntityView';
import { AbvChbkPymtPerspective } from '@/gtn/org/abv/entities/chbkPymt/AbvChbkPymtPerspective';
import { AbvMcdPymtActualsPerspective } from '@/gtn/org/abv/entities/mcdPymtActuals/AbvMcdPymtActualsPerspective';
import { AbvReservePerspective } from '@/gtn/org/abv/entities/reserve/AbvReservePerspective';
import { AbvSapActualsPerspective } from '@/gtn/org/abv/entities/sapActuals/AbvSapActualsPerspective';
import { AbvSapReconPerspective } from '@/gtn/org/abv/entities/sapRecon/AbvSapReconPerspective';
import { Route } from 'react-router-dom';
import { AbvClosureDetail } from './entities/closure/AbvClosureDetail';
import { AbvGtnSalesPerspective } from './entities/gtnSales/AbvGtnSalesPerspective';
import { AbvLbeDetail } from './entities/lbe/AbvLbeDetail';
import { AbvPbmRateDetail } from './entities/lbe/pbmRate/AbvPbmRateDetail';
import { AbvManAccrAdjList } from './entities/manAccrAdj/AbvManAccrAdjList';
import { AbvMediShaPerspective } from './entities/mediSha/AbvMediShaPerspective';
import { AbvMediShaDashboard } from './entities/mediSha/dashboard/AbvMediShaDashboard';
import { AbvOverUnderScenDetail } from './entities/overUnderScen/AbvOverUnderScenDetail';
import { AbvOverUnderScenList } from './entities/overUnderScen/AbvOverUnderScenList';
import { AbvPipeDayDetail } from './entities/overUnderScen/pbmDayGrp/AbvPipeDayDetail';
import { AbvPipeDayGrpDetail } from './entities/overUnderScen/pbmDayGrp/AbvPipeDayGrpDetail';
import { AbvPbmPymtPerspective } from './entities/pbmPymt/AbvPbmPymtPerspective';
import { AbvSapReconDashboard } from './entities/sapReconDashboard/AbvSapReconDashboard';

const abvGtnRoutes = [
  <Route path="gtn/reserve" element={<EntityView perspectiveComponent={AbvReservePerspective} />} />,
  <Route path="gtn/sap-recon" element={<EntityView perspectiveComponent={AbvSapReconPerspective} />} />,
  <Route path="/gtn/dashboard/sap-recon" element={<AbvSapReconDashboard />} />,
  <Route path="gtn/man-accr-adj" element={<EntityView listComponent={AbvManAccrAdjList}/>} />,
  <Route path="gtn/over-under-scen" element={<EntityView listComponent={AbvOverUnderScenList} detailComponent={AbvOverUnderScenDetail}/>} />,
  <Route path="gtn/mcd-pymt-actuals" element={<EntityView perspectiveComponent={AbvMcdPymtActualsPerspective} />} />,
  <Route path="gtn/chbk-pymt" element={<EntityView perspectiveComponent={AbvChbkPymtPerspective} />} />,
  <Route path="gtn/sap-actuals" element={<EntityView perspectiveComponent={AbvSapActualsPerspective} />} />,
  <Route path="gtn/pbm-pymt" element={<EntityView perspectiveComponent={AbvPbmPymtPerspective} />} />,
  <Route path="gtn/ce-code" element={<EntityView />} />,
  <Route path="gtn/unique-client" element={<EntityView />} />,
  <Route path="gtn/pbm-map" element={<EntityView />} />,
  <Route path="gtn/plan" element={<EntityView />} />,
  <Route path="gtn/lbe" element={<EntityView detailComponent={AbvLbeDetail}/>} />,
  <Route path="gtn/pipe-day" element={<EntityView detailComponent={AbvPipeDayDetail}/>} />,
  <Route path="gtn/pipe-day-grp" element={<EntityView detailComponent={AbvPipeDayGrpDetail}/>} />,
  <Route path="gtn/closure" element={<EntityView detailComponent={AbvClosureDetail}/>} />,
  <Route path="gtn/pbm-rate" element={<EntityView detailComponent={AbvPbmRateDetail} />} />,
  <Route path="gtn/lbe-item" element={<EntityView/>} />,
  <Route path="gtn/medi-sha" element={<EntityView perspectiveComponent={AbvMediShaPerspective} />} />,
  <Route path="gtn/medi-sha-dashboard" element={<AbvMediShaDashboard />} />,
  <Route path="gtn/gtn-sales" element={<EntityView perspectiveComponent={AbvGtnSalesPerspective} />} />
]

export default abvGtnRoutes;